/**
 * TD Product Gallery View — thumbnail strip + arrow control.
 * Keeps theme media-gallery sync; arrow advances active thumb and scrolls strip.
 */
(function () {
  const DESKTOP_MQL = window.matchMedia('(min-width: 750px)');

  function initGallery(root) {
    if (!DESKTOP_MQL.matches) return;

    const thumbSlider = root.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbSlider) return;

    const thumbList = thumbSlider.querySelector('[id^="Slider-Thumbnails"]');
    const nextBtn = thumbSlider.querySelector('.slider-button--next');
    if (!thumbList || !nextBtn) return;

    const getItems = () =>
      Array.from(thumbList.querySelectorAll('.thumbnail-list__item'));

    const getActiveIndex = () => {
      const activeBtn = thumbList.querySelector('.thumbnail[aria-current="true"]');
      const activeItem = activeBtn?.closest('.thumbnail-list__item');
      const items = getItems();
      const idx = items.indexOf(activeItem);
      return idx >= 0 ? idx : 0;
    };

    const scrollThumbIntoView = (item) => {
      if (!item) return;
      const listRect = thumbList.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();

      if (itemRect.left < listRect.left) {
        thumbList.scrollLeft -= listRect.left - itemRect.left;
      } else if (itemRect.right > listRect.right) {
        thumbList.scrollLeft += itemRect.right - listRect.right;
      }
    };

    const goToIndex = (index) => {
      const items = getItems();
      if (!items.length) return;

      const nextIndex = ((index % items.length) + items.length) % items.length;
      const nextItem = items[nextIndex];
      const thumbBtn = nextItem?.querySelector('button.thumbnail');

      if (thumbBtn) {
        thumbBtn.click();
      }

      scrollThumbIntoView(nextItem);
    };

    // Theme may disable the button when all slides fit — keep arrow usable
    const keepNextEnabled = () => nextBtn.removeAttribute('disabled');
    keepNextEnabled();
    new MutationObserver(keepNextEnabled).observe(nextBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
    });

    nextBtn.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        goToIndex(getActiveIndex() + 1);
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('[class*="td-gallery-view--"]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[class*="td-gallery-view--"]');
    if (root) initGallery(root);
  });
})();
